import gql from 'graphql-tag';

export const HomeProfileQuery = gql`
	query HomeProfileQuery {
		user(current: true) {
			id
			title
			photos {
				value
				isPrimary
			}
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;

export const HomeHeaderImageQuery = gql`
	query HomeHeaderImageQuery($userId: ID!, $cloudId: ID!) @experimental {
		experimentalCloudUser(userId: $userId, cloudId: $cloudId) {
			headerImageUrl
		}
	}
`;
